import info from './info'
import menu from './menu'
import table from './table'
import userFilters from './userFilters'

export default {
    userId: 'Nutzer {id}',
    newUser: 'Neuer Nutzer',
    createUser: 'Neuen Nutzer anlegen',

    deleteUser: 'Nutzer löschen',
    deleteUserText:
        'Möchten Sie den Nutzer wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.',
    deleteOtherUserText:
        'Möchten Sie den Nutzer {name} wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.',
    deleteOwnUserText:
        'Möchten Sie Ihren Account wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.',
    transferDataText: "Angelegte Maßnahmen & Formulare müssen auf einen Nutzer mit der gleichen Organisation übertragen werden. Bitte wählen Sie einen Nutzer aus.",
    noSelectableUsers: 'Es gibt keine Nutzer, die Sie auswählen können. Mögliche Ursachen sind:\n- Es gibt keinen anderen Nutzer in dieser Organisation.\n- Sie haben mit der aktuellen Rolle keine Berechtigung, um andere Nutzer aus dieser Organisation zu sehen.',
    deleteUserSuccess: 'Nutzer wurde erfolgreich gelöscht.',
    deleteUserError: 'Der Nutzer konnte nicht gelöscht werden.',
    userDeleteInfoError: 'Die Nutzer zur Übertragung konnten nicht geladen werden',

    resendEmailVerificationMailSuccess: 'Verifizierungsmail wurde erfolgreich versendet.',
    resendEmailVerificationMailError: 'Verifizierungsmail konnte nicht versendet werden.',
    impersonateSuccess: 'Erfolgreich als gewählter Nutzer unterwegs.',
    impersonateError: 'Identität konnte nicht übernommen werden.',
    impersonateBanner: 'Als {fullname} {organisation_name} unterwegs.',
    leaveImpersonationSuccess: 'Identität wurde erfolgreich zurückgesetzt.',
    leaveImpersonationError: 'Identität konnte nicht zurückgesetzt werden.',
    leaveImpersonationLink: 'Zurück',
    updateSuccess: 'Nutzer wurde erfolgreich gespeichert',
    saveSuccess: 'Nutzer wurde erfolgreich gespeichert',
    welcome: 'Willkommen {name}!',

    firstname: 'Vorname',
    lastname: 'Nachname',
    email: 'E-Mail',
    phone: 'Telefon',
    profileImage: 'Profilbild',
    profile_image_id: 'Profilbild ID',
    password: 'Passwort',
    passwordRepeat: 'Passwort wiederholen',
    current_organisation_id: 'Aktive Organisation',

    receive_newsletter_for_international_programs: 'Ich interessiere mich für internationalen Jugendaustausch sowie Ferienfreizeiten und bin damit einverstanden, dass ich über aktuelle aej-Veranstaltungen und aej-Materialien zu diesen Themen per E-Mail informiert werde',

    signatureInfo: 'Diese Unterschrift wird derzeit nicht verwendet. Neue Unterschriften können momentan nicht angelegt werden.',
    createSignature: 'Signatur erstellen',
    signed_at: 'Unterschrieben am {date}',
    signatureHidden: 'Die Unterschrift ist nur für die unterschreibende Person selbst sichtbar.',
    signatureOnlyByOwner: 'Eine Unterschrift kann nur von der Person selbst angelegt werden.',
    signatureNone: 'Es ist keine Unterschrift hinterlegt.',

    acceptSignature: {
        title: 'Digitale Unterschrift',
        description: 'Unterschreibe direkt hier in der App.',
        sign: 'Unterschreiben',
        scanQrCode: 'Scannen Sie den QR-Code um zu unterschreiben.',
        missingScanningDevice: 'Kein Gerät zum einscannen?',
        signOnThisDevice: 'Auf diesem Gerät unterschreiben'
    },

    signatureTitle: 'Unterschrift',

    deleteSignature: 'Unterschrift löschen',
    deleteSignatureText: 'Möchten Sie die Unterschrift wirklich löschen?',
    deleteSignatureSuccess: 'Die Unterschrift wurde erfolgreich gelöscht.',
    deleteSignatureError: 'Die Unterschrift konnte nicht gelöscht werden.',


    organisation_id: 'Verknüpfte Organisation',
    user_id: 'Verknüpfter Nutzer',
    role_name: 'Verknüpfte Rolle',
    organisation_user_id: 'Verknüpfung',

    confirmLeave: 'Sie haben nicht gespeicherte Änderungen. Möchten Sie die Seite wirklich verlassen?',

    info,
    menu,
    table,
    userFilters,
}